export const MemberReportConst = {
  ES3: "es3",
  GATEWAY: "gateway",
  TELCO: "telco",
  GAMELOG: "gamelog",
  VBOSS: "vboss",
};
